import React, { useCallback, useState } from 'react';
import { Form } from '@unform/web';

import api from '../../services/api';
import { useModal } from '../../hooks/modal';
import { useToast } from '../../hooks/toast';

import Input from '../../components/Input';
import { CrossIcon } from '../../assets/svg/SVGComponents';
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import SecondaryButton from '../../components/Buttons/SecondaryButton';

import {
  Actions,
  Body,
  CloseButton,
  Container,
  Description,
  Header,
  Title,
} from './styles';

interface IDisqualifyTeamModalProps {
  tournamentId: string;
  teamId: string;
  teamName: string;
  onSuccess: () => void;
}

const DisqualifyTeamModal: React.FC<IDisqualifyTeamModalProps> = ({
  tournamentId,
  teamId,
  teamName,
  onSuccess,
}) => {
  const { closeModal } = useModal();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async (data: { reason: string }) => {
      setLoading(true);
      try {
        await api.patch(
          `/tournaments/${tournamentId}/teams/${teamId}/disqualify`,
          { reason: data.reason || null },
        );
        addToast({
          type: 'success',
          expression: 'Equipe desclassificada',
          description: `A equipe ${teamName} foi desclassificada com sucesso.`,
        });
        onSuccess();
        closeModal();
      } catch (err) {
        addToast({
          type: 'error',
          expression: 'Erro ao desclassificar',
          description:
            'Não foi possível desclassificar a equipe. Tente novamente.',
        });
      } finally {
        setLoading(false);
      }
    },
    [tournamentId, teamId, teamName, onSuccess, addToast, closeModal],
  );

  return (
    <Container>
      <Header>
        <Title>Desclassificar Equipe</Title>
        <CloseButton type="button" onClick={closeModal}>
          <CrossIcon
            width="1rem"
            stroke="#6b7280"
            strokeWidth={2.5}
            fill="none"
          />
        </CloseButton>
      </Header>

      <Body>
        <Description>
          Você está prestes a desclassificar a equipe{' '}
          <strong>{teamName}</strong>. Ela será movida para o final da
          classificação. Você pode informar o motivo abaixo.
        </Description>

        <Form onSubmit={handleSubmit}>
          <Input
            name="reason"
            placeholder="Motivo da desclassificação (opcional)"
          />

          <Actions>
            <SecondaryButton type="button" onClick={closeModal}>
              Cancelar
            </SecondaryButton>
            <PrimaryButton
              type="submit"
              loading={loading}
              style={{ background: '#ef4444', color: '#fff' }}
            >
              Desclassificar
            </PrimaryButton>
          </Actions>
        </Form>
      </Body>
    </Container>
  );
};

export default DisqualifyTeamModal;
